import React from 'react'
import JoinLeftIcon from '@mui/icons-material/JoinLeft';

const MappingIcon = props => (<JoinLeftIcon {...props} />)

export default MappingIcon
